"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgStarCircle(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M12 0c6.626 0 12 5.374 12 12 0 6.628-5.373 12-12 12-6.628 0-12-5.372-12-12C0 5.373 5.372 0 12 0zm0 1.532C6.218 1.532 1.532 6.219 1.532 12c0 5.782 4.686 10.468 10.468 10.468 5.78 0 10.468-4.686 10.468-10.468C22.468 6.22 17.78 1.532 12 1.532zm-.506 4.345c.218-.503.795-.503 1.011.002l1.356 3.123c.028.065.15.154.222.16l3.371.315c.533.051.726.581.35.962l-2.546 2.592a.367.367 0 00-.07.275l.988 3.496c.155.548-.326.895-.798.574l-3.276-2.24c-.045-.032-.16-.032-.205 0l-3.276 2.24c-.471.321-.952-.026-.797-.574l.988-3.499a.366.366 0 00-.07-.273l-2.546-2.59c-.377-.382-.183-.914.35-.962l3.37-.315A.357.357 0 0010.14 9z",
    fill: "inherit",
    fillRule: "nonzero"
  }));
}

var _default = SvgStarCircle;
exports.default = _default;